import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button
} from '@mui/material';

const EditQuoteDialog = ({ open, form, setForm, onClose, onSave }) => {
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Edit Quote</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          name="quote"
          label="Quote"
          fullWidth
          value={form.quote}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant="contained">Update</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditQuoteDialog;